import React, { useState } from "react";
import { ArrowLeft, Monitor, ChevronRight } from "lucide-react";
import LoginActivityView from "./activity/LoginActivityView";

const ActivitySection = ({ onBack }) => {
  const [currentView, setCurrentView] = useState("main"); // 'main', 'login'

  const handleBackToMain = () => {
    setCurrentView("main");
  };

  // Show detailed login activity view
  if (currentView === "login") {
    return <LoginActivityView onBack={handleBackToMain} />;
  }

  // Main Activity menu - Only Login Activity
  return (
    <div className="space-y-6 px-4 sm:px-0">
      {/* Login Activity Section - Using 3-line layout similar to accountprivacy.jsx */}
      <div className="bg-white py-2">
        <h3 className="font-semibold text-black mb-4">Account Activity</h3>

        <button
          onClick={() => setCurrentView("login")}
          className="flex items-center justify-between w-full py-4 border-b border-black hover:bg-gray-100 px-2 transition-colors"
        >
          <div className="flex items-center space-x-3">
            <Monitor className="w-5 h-5 text-gray-600" />
            <div className="text-left">
              <p className="font-medium text-black">Login Activity</p>
              <p className="text-xs text-gray-600">
                Review your account sign-ins and security
              </p>
              <p className="text-xs text-gray-600 mt-1">
                View all devices where your account is logged in
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <ChevronRight className="w-4 h-4 text-gray-600" />
          </div>
        </button>
      </div>

      {/* Information Section */}
      <div className="bg-white rounded-lg p-3 border border-black">
        <p className="text-sm text-gray-600 leading-relaxed">
          <strong className="text-black">Security information.</strong> Monitor your account security
          by reviewing login activity and active sessions. You can see which
          devices and browsers are currently signed in to your account.
        </p>

        <p className="text-xs text-gray-600 mt-2">
          This includes device type (mobile or desktop), browser details, and
          the last active time for each session.
        </p>
      </div>
    </div>
  );
};

export default ActivitySection;